// ============================================================
// key-feature-tab.js
// Scoped per .gwt-yuva-tabs-wrapper so desktop + mobile
// instances initialise and operate independently.
// ============================================================

(function () {
  'use strict';

  // ─── YouTube title fetch (scoped to a wrapper) ───
  function initYouTubeTitles(wrapper) {
    wrapper.querySelectorAll('.howto-video-item').forEach(function (item) {
      var videoId = item.dataset.youtubeId;
      var titleEl = item.querySelector('.video-title');
      if (!videoId || !titleEl) return;

      fetch(
        'https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=' +
          videoId +
          '&format=json'
      )
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to fetch title');
          return response.json();
        })
        .then(function (data) {
          titleEl.textContent = data.title || 'Untitled Video';
        })
        .catch(function () {
          titleEl.textContent = '';
        });
    });
  }

  // ─── Key-features explore list (image swap on click) ───
  function initExploreList(wrapper) {
    // Desktop explore
    var desktopList = wrapper.querySelector('.explore-2 ul');
    if (desktopList) {
      var desktopFirstLi = desktopList.querySelector('li:first-child');
      if (desktopFirstLi) desktopFirstLi.classList.add('active');

      var desktopFirstImg = desktopFirstLi
        ? desktopFirstLi.querySelector('img')
        : null;
      var desktopTargetImg = wrapper.querySelector('.explore-1 img');

      if (desktopFirstImg && desktopTargetImg) {
        desktopTargetImg.setAttribute(
          'src',
          desktopFirstImg.getAttribute('src')
        );
      }

      desktopList.querySelectorAll('li').forEach(function (item) {
        item.addEventListener('click', function () {
          desktopList.querySelectorAll('li').forEach(function (li) {
            li.classList.remove('active');
          });
          this.classList.add('active');

          var newSrc = this.querySelector('img')
            ? this.querySelector('img').getAttribute('src')
            : null;
          if (desktopTargetImg && newSrc) {
            desktopTargetImg.setAttribute('src', newSrc);
          }
        });
      });
    }

    // Mobile explore
    var mobileList = wrapper.querySelector('.content-accordion-explore ul');
    if (!mobileList) {
      mobileList = wrapper.querySelector('.explore-2-mobile ul');
    }
    if (mobileList) {
      var mobileFirstLi = mobileList.querySelector('li:first-child');
      if (mobileFirstLi) mobileFirstLi.classList.add('active');

      var mobileFirstImg = mobileFirstLi
        ? mobileFirstLi.querySelector('img')
        : null;
      var mobileTargetImg = wrapper.querySelector('.explore-1-mobile img');

      if (mobileFirstImg && mobileTargetImg) {
        mobileTargetImg.setAttribute(
          'src',
          mobileFirstImg.getAttribute('src')
        );
      }

      var mobileContentP = wrapper.querySelector(
        '.explore-inner-mobile .inner-accordion-explore p'
      );

      mobileList.querySelectorAll('li').forEach(function (item) {
        item.addEventListener('click', function () {
          mobileList.querySelectorAll('li').forEach(function (li) {
            li.classList.remove('active');
          });
          this.classList.add('active');

          var newSrc = this.querySelector('img')
            ? this.querySelector('img').getAttribute('src')
            : null;
          if (mobileTargetImg && newSrc) {
            mobileTargetImg.setAttribute('src', newSrc);
          }

          if (mobileContentP) {
            mobileContentP.innerHTML = this.innerHTML;
          }
        });
      });
    }
  }

  // ─── FAQ sub-accordions ───
  function initFaqAccordions(wrapper) {
    wrapper.querySelectorAll('.gwt-ft-faq-accordion').forEach(function (faq) {
      var trigger = faq.querySelector('p');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        faq.classList.toggle('active');
      });
    });
  }

  // ─── Main accordion toggle ───
  function initMainAccordion(wrapper) {
    wrapper.querySelectorAll('.gwt-accordion-item').forEach(function (item) {
      var toggle = item.querySelector('.gwt-accordion-toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function (e) {
        e.preventDefault();

        // Preserve scroll position so expanding/collapsing
        // accordion panels never yanks the viewport (SSI-deadzone)
        var scrollY = window.scrollY;

        // Toggle only the clicked panel — leave siblings untouched
        // so multiple accordions can stay open at the same time
        item.classList.toggle('active');

        // If we just opened it, let the CSS transition finish
        // then update any swipers inside
        if (item.classList.contains('active')) {
          setTimeout(function () {
            item.querySelectorAll('.swiper').forEach(function (s) {
              if (s.swiper) s.swiper.update();
            });
          }, 450);
        }

        // Restore scroll position to prevent jump
        window.scrollTo(0, scrollY);
      });
    });
  }

  // ─── Video modal ───
  function initVideoModal(wrapper) {
    var modal = wrapper.querySelector('.video-modal');
    if (!modal) return;

    var iframe = modal.querySelector('iframe');
    var closeBtn = modal.querySelector('.video-close');
    var overlay = modal.querySelector('.video-modal-overlay');

    function closeModal() {
      modal.classList.remove('active');
      if (iframe) iframe.src = '';
      document.body.style.overflow = '';
    }

    wrapper.querySelectorAll('.howto-video-item').forEach(function (item) {
      item.addEventListener('click', function () {
        var ytId = this.dataset.youtubeId;
        if (ytId && iframe) {
          iframe.src =
            'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0';
          modal.classList.add('active');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (overlay) overlay.addEventListener('click', closeModal);
  }

  // ─── Swipers — scoped per wrapper ───
  function initSwipers(wrapper) {
    wrapper.querySelectorAll('.swiper').forEach(function (el) {
      if (el.classList.contains('swiper-initialized')) return;

      // Walk up to find the closest container with nav/pagination elements
      var parentSection =
        el.closest('.gwt-vm-section') ||
        el.closest('.gwt-accordion-content') ||
        el.parentElement;

      // Try to find pagination element
      var paginationEl =
        parentSection.querySelector('.gwt-pagination-blogs-desktop') ||
        parentSection.querySelector('.gwt-pagination-reviews-desktop') ||
        parentSection.querySelector('.gwt-pagination-about-desktop') ||
        parentSection.querySelector('.swiper-pagination') ||
        null;

      // Try to find next button
      var nextEl =
        parentSection.querySelector('.gwt-next-blogs-desktop') ||
        parentSection.querySelector('.gwt-next-reviews-desktop') ||
        parentSection.querySelector('.gwt-next-about-desktop') ||
        parentSection.querySelector('.swiper-button-next') ||
        null;

      // Try to find prev button
      var prevEl =
        parentSection.querySelector('.gwt-prev-blogs-desktop') ||
        parentSection.querySelector('.gwt-prev-reviews-desktop') ||
        parentSection.querySelector('.gwt-prev-about-desktop') ||
        parentSection.querySelector('.swiper-button-prev') ||
        null;

      new Swiper(el, {
        slidesPerView: 1,
        spaceBetween: 30,
        loop: false,
        autoHeight: true,
        pagination: paginationEl
          ? {
              el: paginationEl,
              type: 'fraction',
              formatFractionCurrent: function (n) {
                return n;
              },
              formatFractionTotal: function (n) {
                return n;
              },
            }
          : false,
        navigation:
          nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      });
    });
  }

  // ─── Master init — loops every wrapper instance ───
  function initAllWrappers() {
    document
      .querySelectorAll('.gwt-yuva-tabs-wrapper')
      .forEach(function (wrapper) {
        // Guard against double-init
        if (wrapper.dataset.gwtInitialized === 'true') return;
        wrapper.dataset.gwtInitialized = 'true';

        initYouTubeTitles(wrapper);
        initExploreList(wrapper);
        initFaqAccordions(wrapper);
        initMainAccordion(wrapper);
        initVideoModal(wrapper);
        initSwipers(wrapper);
      });
  }

  // ─── Run on DOMContentLoaded ───
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllWrappers);
  } else {
    initAllWrappers();
  }
})();